/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
import React, { lazy, useState, useEffect, Suspense, useContext } from 'react';
import Loaders from 'components/atoms/Loaders';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/authContext';
import PageTemplate from '../components/templates/PageTemplate';
import pages from '../nav.json';

// eslint-disable-next-line no-console
const importView = file => lazy(() => import(`./${file}`).catch(() => console.log(`Error in importing ${file}`)));

export default function Index() {
  const { allowedPages, loading_user, user } = useContext(AuthContext);
  const history = useNavigate();
  const [showMap, setShowMap] = useState(false);

  const { view, child } = useParams();
  const metaViewData = pages;
  const [selectedView, setSelectedView] = useState([]);

  async function loadView(filtered) {
    const promise = filtered.map(async _view => {
      const View = await importView(_view?.file);

      return <View key={_view?.id} selectView={selectView} />;
    });
    Promise.all(promise).then(setSelectedView);
  }
  async function selectView(file) {
    const filtered = metaViewData
      .map(({ subNav = [], ...item }) => [item, ...subNav])
      .flat(Infinity)
      .filter(elem => elem.file === file);
    loadView([filtered[0]]);
  }

  useEffect(() => {
    if (user?.email && !loading_user) {
      let fileToLoad = view;

      if (!allowedPages.includes(fileToLoad)) {
        fileToLoad = allowedPages.length > 0 ? allowedPages[0] : 'dashboard';
      }
      if (
        !metaViewData
          .filter(({ live }) => live)
          // eslint-disable-next-line no-shadow
          .map(({ file, subNav = [] }) => [file, ...subNav.filter(({ live }) => live).map(({ file }) => file)])
          .flat(Infinity)
          .includes(fileToLoad) ||
        !fileToLoad ||
        fileToLoad === 'null' ||
        fileToLoad === 'dashboard/null'
      ) {
        fileToLoad = 'dashboard';
      }
      if (allowedPages.length === 1 && allowedPages[0] === 'no-permissions') {
        fileToLoad = 'no-permissions';
      }

      if (allowedPages.includes(fileToLoad)) {
        fileToLoad = allowedPages[allowedPages.indexOf(fileToLoad)];
      }
      // if (!user.is_email_verified) {
      //   fileToLoad = 'check-email';
      // } else
      if (!user?.company_id) {
        fileToLoad = 'create-business-profile';
      } else if (user.company_id.status !== 'Active') {
        fileToLoad = 'verification';
      }
      if (child && allowedPages.includes(child)) {
        fileToLoad = child;
      }
      if (metaViewData?.filter(elem => elem?.file === view)[0]?.file === 'campaigns') {
        setShowMap(true);
      } else {
        setShowMap(false);
      }
      if (child) {
        history(`/brand/${view}/${fileToLoad}`, { replace: true });
        setShowMap(false);
      } else {
        history(`/brand/${fileToLoad}`, { replace: true });
      }
      selectView(fileToLoad);
      console.log({ fileToLoad });
    }
  }, [view, loading_user, child]);
  return loading_user ? (
    <Loaders pageLoader />
  ) : (
    <PageTemplate
      title={view}
      showTemplate={
        metaViewData
          .map(({ subNav = [], ...item }) => [item, ...subNav])
          .flat(Infinity)
          .filter(elem => elem.file === view)[0]?.navigations ||
        metaViewData
          .map(({ subNav = [], ...item }) => [item, ...subNav])
          .flat(Infinity)
          .filter(elem => elem.file === view)[0]?.showTemplate
      }
      topBar
      showMap={showMap}>
      <Suspense fallback={<Loaders viewLoader />}>{selectedView}</Suspense>
    </PageTemplate>
  );
}
